// extracted by mini-css-extract-plugin
var _1 = "Editor_color__OInEs";
var _2 = "Editor_colorButton__DUqGL";
var _3 = "Editor_colorButtonActive__gr5v-";
var _4 = "Editor_colorButtons__Tnau1";
var _5 = "Editor_colorInput__SDJis";
var _6 = "Editor_colorSwatch__D0TNC";
var _7 = "Editor_text__zolDF";
var _8 = "Editor_wrapper__vW3wL";
export { _1 as "color", _2 as "colorButton", _3 as "colorButtonActive", _4 as "colorButtons", _5 as "colorInput", _6 as "colorSwatch", _7 as "text", _8 as "wrapper" }
